<template>
  <div v-if="customIsVisible" :class="[backgroundColor, bottomMargin, verticalPadding, background]" class="image-links">
    <div class="mx-auto w-full max-w-screen-2xl px-5 md:px-12">
      <VcTypography v-if="title" :tag="heading" :anchor-id="title" class="w-full mb-8">
        {{ title }}
      </VcTypography>
      <div class="flex flex-wrap w-full gap-4">
        <div v-for="imageLink in imageLinks">
          <RouterLink v-if="imageLink.linkUrl" :to="imageLink.linkUrl">
            <div
              class="w-[220px] h-[90px] select-none rounded-lg border border-[--color-body-bg-alt-1] bg-center bg-no-repeat"
              :class="{ 'bg-cover': imageLink.backgroundCover }"
              :style="{ backgroundImage: `url(${imageLink.image})` }"
              :title="imageLink.imageDescription"
            ></div>
          </RouterLink>

          <div
            v-else
            class="w-[220px] h-[90px] select-none rounded-lg border border-[--color-body-bg-alt-1] bg-center bg-no-repeat"
            :class="{ 'bg-cover': imageLink.backgroundCover }"
            :style="{ backgroundImage: `url(${imageLink.image})` }"
            :title="imageLink.imageDescription"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
type ImageLink = {
  image: string;
  imageDescription: string;
  linkUrl?: string;
  backgroundCover?: boolean;
};

interface IProps {
  id: string;
  heading?: string;
  title?: string;
  imageLinks?: ImageLink[];
  lazy?: boolean;

  background?: string;
  model: any;
  settings: any;

  // Innovadis custom: Use custom visibility setting
  customIsVisible: boolean;

  // Innovadis custom: Use custom layout settings
  backgroundColor: string;
  bottomMargin: string;
  verticalPadding: string;
}

const props = withDefaults(defineProps<IProps>(), {
  heading: "h2",
  lazy: true,
});
</script>
